import React, { useState } from 'react';
import * as Yup from 'yup';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import axios from 'axios';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
import { useSettingContext } from '../../context/setting_context';
import SearchTariffList from './SearchTariffList';

export default function SearchTariff() {
  const { setTariffList } = useSettingContext();
  const [showList, setShowList] = useState(false);
  const [noOfRecords, setNoOfRecords] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();

  const PersonalDetailsSchema = Yup.object().shape({
    surname: Yup.string().max(50, 'Tarriff is too Long!')
  });

  const formik = useFormik({
    initialValues: {
      tariffName: '',
      tariffNumber: ''
    },
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      setShowList(false);
      search(values);
      // handleSearch(values);
    }
  });

  const recordsReturned = (data) => {
    console.log('check my data', data);
    if (data.length > 0) {
      setTariffList(data);
      setShowList(true);
      setNoOfRecords(data.length);
    } else {
      setNoOfRecords(0);
    }
  };

  const search = async (values) => {
    if (values.tariffName === '' && values.tariffNumber === '') {
      notifyPopup(`Please enter Criteria to Search e.g. Enter Tariff!`, 'error');
      return;
    }
    let strValues = '';
    let searchKeys = 1;
    if (values.tariffName !== '') {
      strValues = values.tariffName;
      searchKeys = 1;
    }
    if (values.tariffNumber !== '') {
      strValues = values.tariffNumber;
      searchKeys = 2;
    }
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      params: {
        searchKey: searchKeys,
        strValue: strValues,
        firstName: 'temp'
      }
    };
    setLoading(true);
    // clearContext();

    axios.get(`${baseUrl}/api/setting/TariffSearchAdvanced`, config).then(
      (result) => {
        setLoading(false);
        if (result.data.totalRecordCount === 0) {
          setNoOfRecords(0);
          setShowList(false);
          notifyPopup(
            `No Members Found with Specified Criteria: ${result.replyMessage}`,
            'success'
          );
        } else {
          recordsReturned(result.data);
        }
      },
      (error) => {
        console.log('Fatal Error is', error);
        notifyPopup(`Fatal Error in Retrieving Members Search List!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleNewClient = () => {
    console.log('entered here');
    // openNew();
  };

  const handleClear = () => {
    formik.setFieldValue('tariffName', '');
    formik.setFieldValue('tariffNumber', '');
  };

  const openNew = () => {
    navigate('/clientportfolio/registerclient/00000000-0000-0000-0000-000000000000');
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
                onClick={handleLoadingClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Typography component="span" variant="h6" gutterBottom>
                Search for Member
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="tariffName" label="Tariff Name" />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="tariffNumber" label="Tariff #" />
                </Grid>
              </Grid>
              <Grid container margin={2} direction="row" justifyContent="right" alignItems="right">
                <Grid item xs={12} sm={2}>
                  <Button
                    type="submit"
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    // onClick={() => search()}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    type="button"
                    variant="outlined"
                    startIcon={<ClearIcon />}
                    onClick={() => handleClear()}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
      {showList === false && noOfRecords === 0 && (
        <div style={{ margin: '10px 300px', color: 'red', fontWeight: '800' }}>
          No clients exists for selected criteria...
          {/* {notifyPopup(`No clients exists for selected criteria...`, 'No Clients Found')} */}
        </div>
      )}
      {showList === true && <SearchTariffList />}
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
